import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const MARQUEE_ITEMS = [
  "بنشر متنقل الرياض",
  "إصلاح البنشر",
  "تغيير كفرات متنقل",
  "بيع الإطارات",
  "جنوط الرياض",
  "برمجة حساسات TPMS",
  "ترصيص الإطارات",
  "فحص وتعبئة الهواء",
  "خدمة 24 ساعة",
  "نصلك أينما كنت",
];

export const Marquee = () => (
  <div className="marquee border-y border-gold/25 bg-panel py-3.5 select-none" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center gap-6 px-6">
              <span className="font-display font-bold text-lg text-white/85 whitespace-nowrap">{item}</span>
              <svg width="10" height="10" viewBox="0 0 10 10" className="text-gold shrink-0">
                <path d="M5 0l1.3 3.7L10 5 6.3 6.3 5 10 3.7 6.3 0 5l3.7-1.3z" fill="currentColor" />
              </svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
